/** Session memory of image URLs that finished loading on the storefront. */
const loadedImageSrcs = new Set<string>()

export function isImageSrcLoaded(src?: string | null): boolean {
  const href = src?.trim()
  if (!href) return false
  if (loadedImageSrcs.has(href)) return true

  const probe = new Image()
  probe.src = href
  if (probe.complete && probe.naturalWidth > 0) {
    loadedImageSrcs.add(href)
    return true
  }

  return false
}

export function markImageSrcLoaded(src?: string | null): void {
  const href = src?.trim()
  if (href) loadedImageSrcs.add(href)
}

export function preloadImageSrc(src?: string | null): void {
  const href = src?.trim()
  if (!href || isImageSrcLoaded(href)) return

  const img = new Image()
  img.onload = () => markImageSrcLoaded(href)
  img.src = href
}

export function preloadImageSrcs(sources: Array<string | null | undefined>): void {
  for (const src of sources) preloadImageSrc(src)
}
